import * as React from 'react';
import { DcfRequestStatusEnum } from '../../misc/api/apiTypes';

interface DataCorrectionStatusProps {
    value: DcfRequestStatusEnum;
}

export const DataCorrectionStatus = (props: DataCorrectionStatusProps) => {
    let colour, name;

    switch (props.value) {
        case DcfRequestStatusEnum.SiteApproval:
            colour = 'primary';
            name = 'Site Approval';
            break;
        case DcfRequestStatusEnum.VerificationReview:
            colour = 'warning';
            name = 'CRA Approval';
            break;
        case DcfRequestStatusEnum.VitalographApproval:
            colour = 'warning';
            name = 'Vitalograph Approval';
            break;
        case DcfRequestStatusEnum.Approved:
            colour = 'success';
            name = 'Processing';
            break;
        case DcfRequestStatusEnum.Implemented:
            colour = 'success';
            name = 'Implemented';
            break;
        case DcfRequestStatusEnum.RejectedWithSuggestions:
            colour = 'warning';
            name = 'Rejected With Suggestions';
            break;
        case DcfRequestStatusEnum.Rejected:
            colour = 'danger';
            name = 'Rejected';
            break;
    }

    return (
        <span className={'label title label-' + colour}>{name}</span>
    );
}
